import React, { useState, useEffect } from "react";
import {
  useStaticQuery,
  graphql,
} from 'gatsby';
import {
  Image,
  ImageLayer,
  Wrap,
  Title,
  Description,
  Frame,
  Video,
} from './hero.styled';
import { getImage } from "gatsby-plugin-image";
import GalleryFullScreen from "../../components/gallery/gallery-fullscreen";
import HeroVideoMP4 from "../../assets/video/hero_video_large.mp4";



// THERE WAS IMAGE FLICKERING ON TRANSITION THEREFORE I CHOOSE TO HAVE IMAGE LAYERS (2nd layer is on top of the other)

const HeroImages = () => {
  const [paused, setPaused] = useState(false);
  const [clicked, setClicked] = useState(false);
  const data = useStaticQuery(graphql`
    query {
      heroImage_0: file(relativePath: { eq: "betriton-hero.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
      heroImage_1: file(relativePath: { eq: "betriton-hero-1.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
      heroImage_2: file(relativePath: { eq: "betriton-hero-2.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
      heroImage_3: file(relativePath: { eq: "betriton-hero-3.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
      heroImage_4: file(relativePath: { eq: "betriton-hero-4.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
      heroImage_5: file(relativePath: { eq: "betriton-hero-5.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 2560, quality: 100, breakpoints: [820, 360], placeholder: BLURRED)
        }
      }
    }
  `);

  const images = [
    getImage(data.heroImage_0),
    getImage(data.heroImage_1),
    getImage(data.heroImage_2),
    getImage(data.heroImage_3),
    getImage(data.heroImage_4),
    getImage(data.heroImage_5),
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (paused || clicked) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [paused, clicked, images.length]);

  const handleMouseEnter = () => setPaused(true);
  const handleMouseLeave = () => setPaused(false);

  const handleClick = () => {
    setClicked(true);
    setIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <ImageLayer
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {images.map((img, i) => (
        <Image key={i} correction={`${i}`} image={img} alt="BeTRITON hero" activeimage={i === index ? "true" : "false"} />
      ))}
    </ImageLayer>
  );
};


const HeroVideo = () => {
  // const { heroVideo } = useStaticQuery(
  //   graphql`
  //   query {
  //     heroVideo: file(relativePath: {eq: "assets/BeTriton_Website_HeroVideo_Large.mp4"}) {
  //       absolutePath
  //     }
  //   }
  // `)
  return (
    <Video muted video autoPlay="autoplay" loop="loop" defaultMuted playsinline oncontextmenu="return false;" preload="auto" id="myVideo">
      <source src={HeroVideoMP4} type="video/mp4" />
      {/* <source src={heroVideo.absolutePath} type="video/mp4" /> */}
    </Video>
  )

}


export const Hero = ({ title, description, video }) => {
  const [fullScreenIndex, setFullScreenIndex] = useState(null);
  const data = [
    {
      "type": "youtube",
      "youtube": "https://www.youtube.com/embed/bHpCEUSWt7Q"
    }
  ]
  const fullScreenData = fullScreenIndex !== null ? data[fullScreenIndex] : null;

  const enterFullScreen = () => {
    setFullScreenIndex(0);
  }

  const handleClose = (event) => {
    event.preventDefault();
    setFullScreenIndex(null);
  }
  return (
    <>
      {fullScreenData
        ? (
          <GalleryFullScreen
            data={{
              type: fullScreenData.type,
              youtube: fullScreenData.youtube,
            }}
            disableNavigation
            onNext={() => { }}
            onPrev={() => { }}
            onClose={handleClose}
            forcedType="youtube"
          />
        )
        : ''}
      <Wrap>
        <Frame wrapper>
          <Frame background>
            {/* <HeroVideo /> */}
            <HeroImages />
          </Frame>
          <Frame container>
            <Frame text>
              <Title>{title}</Title>
              <Description>{description}</Description>
              {/* <div>
                <PlayButton onClick={enterFullScreen}>
                  <Icon
                    name="caret-forward-sharp"
                    size={50}
                    noFill
                  />
                </PlayButton>
              </div> */}
            </Frame>
          </Frame>
        </Frame>
      </Wrap>
    </>
  )
}

export default Hero;
